// extracted by mini-css-extract-plugin
export default {"FlightEntryPagination":"FlightEntryPagination_FlightEntryPagination__OTVhM"};